export function renderMetaKeywords(keywords: string[]) {
  return <meta name="keywords" content={keywords.join(' ')} />;
}

export default renderMetaKeywords;
